import { FormGroup, Grid, TextField } from "@mui/material";
import HESPFormLabel from "../HESPFormLabel/HESPFormLabel";
import { HelperText } from "../HESPFormLabel/HESPFormLabel";

interface Props {
    url: string;
    googleDaiNetworkCode: string;
    sseCdnEndpointUrl: string;
    onChangeUrl: (url: string) => void;
    onChangeGoogleDaiNetworkCode: (code: string) => void;
    onChangeSseCdnEndpointUrl: (url: string) => void;
}

export default function OrganizationChannelTHEOads({
    onChangeUrl,
    url,
    sseCdnEndpointUrl,
    googleDaiNetworkCode,
    onChangeGoogleDaiNetworkCode,
    onChangeSseCdnEndpointUrl,
}: Props): JSX.Element {
    function isValidUrl(url: string): boolean {
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormGroup style={{ minWidth: "300px" }}>
                    <HESPFormLabel label="Ads URL" />
                    <TextField
                        fullWidth
                        type="text"
                        size="small"
                        placeholder="Ads URL"
                        onChange={(e) => onChangeUrl(e.target.value)}
                        variant="outlined"
                        key="ads-url"
                        value={url}
                    />
                    {!isValidUrl(url) && <HelperText color="error">Should be a valid URL</HelperText>}
                </FormGroup>
            </Grid>

            <Grid item xs={12}>
                <FormGroup style={{ minWidth: "300px" }}>
                    <HESPFormLabel label="CDN endpoint for SSE URL" />
                    <TextField
                        fullWidth
                        type="text"
                        size="small"
                        placeholder="CDN URL"
                        onChange={(e) => onChangeSseCdnEndpointUrl(e.target.value)}
                        variant="outlined"
                        key="ads-url"
                        value={sseCdnEndpointUrl}
                    />
                    {!isValidUrl(sseCdnEndpointUrl) && <HelperText color="error">Should be a valid URL</HelperText>}
                </FormGroup>
            </Grid>

            <Grid item xs={12}>
                <FormGroup style={{ minWidth: "300px" }}>
                    <HESPFormLabel label="Google DAI network code" />
                    <TextField
                        fullWidth
                        type="text"
                        size="small"
                        placeholder="Google DAI network code"
                        onChange={(e) => onChangeGoogleDaiNetworkCode(e.target.value)}
                        variant="outlined"
                        key="ads-network-code"
                        value={googleDaiNetworkCode}
                    />
                    {googleDaiNetworkCode.trim().length === 0 && (
                        <HelperText color="error">Google DAI network code is mandatory</HelperText>
                    )}
                </FormGroup>
            </Grid>
        </Grid>
    );
}
